import { USDC_DUST_THRESHOLD, USDC_DUST_THRESHOLD_D6 } from '@/config/solana';

/** Returns true if the float balance is below the dust threshold ($0.01). */
export function isDust(amount: number): boolean {
  return Math.abs(amount) < USDC_DUST_THRESHOLD;
}

/** Returns true if the D6-encoded value is below the dust threshold (10_000). */
export function isDustD6(d6Value: string | number): boolean {
  const num = typeof d6Value === 'string' ? Number(d6Value) : d6Value;
  return Math.abs(num) < USDC_DUST_THRESHOLD_D6;
}
